const KEY_ID = "selectedStudioId";
const KEY_ROLES = "selectedStudioRoles";

export function setSelectedStudio(studio) {
  const studioId = studio?.studioId || studio?.id || null;
  if (studioId) localStorage.setItem(KEY_ID, studioId);

  // GetUserStudios response: roles (List<string>)
  const roles = Array.isArray(studio?.roles) ? studio.roles : [];
  localStorage.setItem(KEY_ROLES, JSON.stringify(roles));

  // Convenience
  localStorage.setItem("selectedStudioIsOwner", studio?.isOwner ? "1" : "0");
  localStorage.setItem("selectedStudioIsAdmin", studio?.isAdmin ? "1" : "0");

  return { studioId, roles };
}

export function getSelectedStudioId() {
  return localStorage.getItem(KEY_ID);
}

export function getSelectedStudioRoles() {
  try {
    const raw = localStorage.getItem(KEY_ROLES);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

